module.exports = __webpack_public_path__ + "static/media/defaultimg.f717778d.svg";